import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAddColumn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.667 8.333h-10V10h10V8.333zm0-3.333h-10v1.667h10V5zM15 11.667V8.333h-1.667v3.334H10v1.666h3.333v3.334H15v-3.334h3.333v-1.666H15zM1.667 13.333h6.666v-1.666H1.667v1.666z",
		fillRule: "nonzero"
	})
});
export default SvgAddColumn;
